import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

const SessionExpired = () => {
  const navigate = useNavigate();

  const handleRedirectToLogin = () => {
    navigate("/login");
  };

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h2>Your session has expired. Please log in again.</h2>
      <Button type="primary" onClick={handleRedirectToLogin}>
        OK
      </Button>
    </div>
  );
};

export default SessionExpired;
